import React from "react";
import {
  Button,
  Dialog,
  Card,
  CardBody,
  CardFooter,
  Typography,
} from "@material-tailwind/react";

const NofificationModal = ({ isOpen, handleModalToggle, modalData }) => {
  return (
    <Dialog
      size="xs"
      open={isOpen}
      handler={handleModalToggle}
      className="bg-transparent shadow-none"
    >
      <Card className="mx-auto w-full max-w-[24rem]">
        <CardBody className="flex flex-col gap-2 text-gray-800">
          <Typography variant="h4" color="blue-gray">
            {modalData.title}
          </Typography>
          <div className="flex  justify-between items-center gap-2">
            <div className="    h-20  w-1/3  ">
              <img src={modalData.storeLogo} alt="" />
            </div>
            <div className="w-2/3 py-4 text-sm  flex flex-col">
              <div
                className="mb-3  font-bold "
                variant="paragraph"
                color="gray"
              >
                {modalData.description}
              </div>
              <div className=" text-xs">{modalData.storeName}</div>
            </div>
          </div>
        </CardBody>
        <CardFooter className="flex justify-end gap-3 pt-0 ">
          {modalData.redButton && (
            <Button
              className={`px-2 w-28 py-2 bg-red-800`}
              onClick={handleModalToggle}
            >
              {modalData.redButton}
            </Button>
          )}
        </CardFooter>
      </Card>
    </Dialog>
  );
};

export default NofificationModal;
